import { render, staticRenderFns } from "./Picklist.vue?vue&type=template&id=631cb36c&scoped=true&"
import script from "./Picklist.vue?vue&type=script&lang=js&"
export * from "./Picklist.vue?vue&type=script&lang=js&"
import style0 from "./Picklist.vue?vue&type=style&index=0&id=631cb36c&prod&lang=scss&scoped=true&"
import style1 from "./Picklist.vue?vue&type=style&index=1&id=631cb36c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cb36c",
  null
  
)

export default component.exports